import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
const CHECKOUT_URL = 'https://pzhbwp-zj.myshopify.com/cart/43946659938439:1';

// ✅ Apagá/encendé el pixel desde acá
const ENABLE_PIXEL = false;
const PIXEL_ID = '1454766452919113';
function initMetaPixel(pixelId: string) {
  if (!ENABLE_PIXEL || !pixelId) return;
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.fbq) return;
  const fbq: any = function (...args: any[]) {
    fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  w.fbq = fbq;
  w._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  fbq('init', pixelId);
  fbq('track', 'PageView');
}
export function trackInitiateCheckout() {
  if (!ENABLE_PIXEL) return;
  const w = window as any;
  if (w.fbq) w.fbq('track', 'InitiateCheckout');
}
export function App() {
  useEffect(() => {
    initMetaPixel(PIXEL_ID);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = CHECKOUT_URL;
    link.as = 'document';
    document.head.appendChild(link);
  }, []);
  return <LandingPage data-id="element-0" />;
}